import formatting from './formatting.js'
import api from '../apiBridge'

export default {

    // formatting functions added here as needed
    
    dateFormat: {

        timeHMampm: function (dtValue) {
            var hours, minutes;
            
            // take date or string as argument
            // string argument should contain 24hr time only
            if (dtValue instanceof Date) {
                hours = dtValue.getHours();
                minutes = dtValue.getMinutes();
            } else if (typeof dtValue === 'string') {
                var aTime = dtValue.split(':');
                if (aTime.length != 2) return null;

                hours = parseInt(aTime[0]);
                minutes = parseInt(aTime[1]);
            } else {
                return null;
            }

            var ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? '0'+minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        },

        timeHM24: function (a1,a2) {
            // take date or string as argument1 
            // string argument should contain 24hr time only
            // takes number or string numbers as arguments otherwise

            var h=0;
            var m=0;

            if (a1 instanceof Date) {
                h = a1.getHours();
                m = a1.getMinutes();
            } else if (typeof a1 === 'string' && !a2) {
                var aTime = a1.split(':');
                if (aTime.length != 2) return null;

                h = parseInt(aTime[0]);
                m = parseInt(aTime[1]);
            } else if (typeof a1 != 'undefined' && typeof a2 != 'undefined' ) {
                h = a1;
                m = a2;
            } else {
                return null;
            }

            return formatting.numberFormat.pad(h,2) + ':' +  formatting.numberFormat.pad(m,2);
        },

        dateFromStr(s) {
            // polyfill for Safari browsers
            // build date from string of standard format:  yyyy-mm-ddThh:mm
            // NOTE: seconds are ignored
            if (!s) return null;
            var aDate = s.split(/[^0-9]/);
            var newDate
            if (aDate[3] && aDate[4] && aDate[5]) {
                newDate = new Date(aDate[0],aDate[1]-1,aDate[2],aDate[3],aDate[4],aDate[5]);
            } else if (aDate[3] && aDate[4]) {
                newDate = new Date(aDate[0],aDate[1]-1,aDate[2],aDate[3],aDate[4]);
            } else {
                newDate = new Date(aDate[0],aDate[1]-1,aDate[2]);
            }
            return newDate;
        },

        calcElapsedTime(startTime, currentTime) {
            // later record end time
            var endTime = currentTime || new Date();
      
            // time difference in ms
            var timeDiff = endTime - startTime;
      
            // strip the miliseconds
            timeDiff /= 1000;
            var seconds = Math.round(timeDiff % 60);
      
            // remove seconds from the date
            timeDiff = Math.floor(timeDiff / 60);
            var minutes = Math.round(timeDiff % 60);
      
            // figure out display colour
            var displayColour = '#FF0000'; // red
            if (timeDiff < 10) {
              displayColour = '#008000'; // green
            } else if (timeDiff < 20) {
              displayColour = '#00008b'; // dark blue
            }

            const totalMinutes = timeDiff;
      
            // remove minutes from the date
            timeDiff = Math.floor(timeDiff / 60);
            var hours = Math.round(timeDiff % 24);
      
            // remove hours from the date
            timeDiff = Math.floor(timeDiff / 24);
            // the rest of timeDiff is number of days
            var days = timeDiff;
      
            // format display values
            var sDays = (days) 
                      ? days + 'D '
                      : '';
      
            var sHours = (hours) 
                      ? hours + ':'
                      : '';
      
            var sMinutes = (hours) 
                      ? formatting.numberFormat.pad(minutes)
                      : minutes;
      
            return {
                    time: sDays + sHours + sMinutes + ':' + formatting.numberFormat.pad(seconds),
                    totalMinutes:  totalMinutes,
                    colour: displayColour
            };
          },

          calcDiffInMinutes(dt2, dt1) {
            let diff =(dt2.getTime() - dt1.getTime()) / 1000;
            diff /= 60;
            return Math.abs(Math.round(diff));
          }
    },

    numberFormat: {
        pad: function (n, width, z) {
            z = z || '0';
            n = n + '';
            width = width || 2;
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        },
        roundTo2Dec: function(num) {
            return Math.round(num * 100) / 100;
        }
    },

    stringFormat: {
        capitalize (str) {
            // capitalize every token in string

            if (!str) return str;

            let aStr = (''+str).split(' ');
            let sCapitalized = '';

            for (let s=0; s<aStr.length; s++) {
                if (sCapitalized) {
                    // add space after
                    sCapitalized += ' ';
                }
                sCapitalized += aStr[s].charAt(0).toUpperCase() + aStr[s].slice(1).toLowerCase();
            }
            
            return sCapitalized;
        },

        truncateWithEllipsis (str, n){
            return (str.length > n) ? str.substr(0, n-1) + '...' : str;
        }        
    }

}



// WEBPACK FOOTER //
// ./src/common/formatting.js